export default __webpack_public_path__ + "static/media/Judul-Nitijana.2dedd237.png";